import type { EnvVisibility } from '@hangar/shared';
import { FormField, fieldA11y } from '@/components/FormField';
import { Textarea } from '@/components/ui/textarea';
import { OptionSelect } from '@/components/OptionSelect';
import type { ImportConflict } from './importModel';
import type { ImportFormApi } from './useImportForm';

export function ImportFields({ f }: { f: ImportFormApi }) {
  return (
    <>
      <FormField id="env-import-content" label="Document" required error={f.error}>
        <Textarea
          data-testid="env-import-content"
          value={f.content}
          onChange={(e) => f.setContent(e.target.value)}
          rows={8}
          spellCheck={false}
          className="font-mono sm:text-[13px]"
          placeholder={'APP_ENV=staging\nEXPO_PUBLIC_API_URL=https://api.staging.example.com\nLICENSE_KEY="line1\\nline2"'}
          {...fieldA11y('env-import-content', f.error)}
        />
      </FormField>
      <ImportOptions f={f} />
      <FormField id="env-import-note" label="Version note">
        <Textarea data-testid="env-import-note" value={f.note} onChange={(e) => f.setNote(e.target.value)} rows={2} maxLength={500} placeholder="Imported from Bitbucket repository variables" />
      </FormField>
    </>
  );
}

function ImportOptions({ f }: { f: ImportFormApi }) {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <FormField id="env-import-visibility" label="Default visibility" hint="Per-key overrides come from the preview">
        <OptionSelect
          id="env-import-visibility"
          data-testid="env-import-visibility"
          value={f.defaultVisibility}
          onValueChange={(v) => f.setDefaultVisibility(v as EnvVisibility)}
          aria-describedby="env-import-visibility-hint"
          options={[
            { value: 'plain', label: 'plain' },
            { value: 'sensitive', label: 'sensitive' },
            { value: 'secret', label: 'secret' },
          ]}
        />
      </FormField>
      <FormField id="env-import-conflict" label="Existing keys">
        <OptionSelect
          id="env-import-conflict"
          data-testid="env-import-conflict"
          value={f.onConflict}
          onValueChange={(v) => f.setOnConflict(v as ImportConflict)}
          options={[
            { value: 'new_version', label: 'Create a new version' },
            { value: 'skip', label: 'Skip' },
            { value: 'fail', label: 'Fail the import' },
          ]}
        />
      </FormField>
    </div>
  );
}
